import * as _ from 'lodash-es';
import { ReservationBuilder } from './reservation-builder';
import { Agent } from '../model/agent';
import { AgentPremium, LocationAgent } from '../model/agent-premium';
import { AgentProduct } from '../model/agent-product';
import { AgentProductRights } from '../model/agent-product';
import { AgentProductPermissions } from '../model/agent-product';
import { AgentServicePhoto } from '../model/agent-service-photo';
import { AgentServicePhotosList } from '../model/agent-service-photos-list';
import { AgentServicesList } from '../model/agent-services-list';
import { AdminPermissionsGroup } from '../model/adminPermissionsGroup';
import { AdminPermissions } from '../model/adminPermissions';
export class AgentBuilder {
    static buildAgent(data) {
        const agent = new Agent();
        agent.id = data.agent_id;
        agent.appLot = data.app_lot;
        agent.currentLot = data.id_last_lot;
        agent.email = data.email;
        agent.name = data.name;
        agent.lastName = data.surname;
        agent.phone = data.phone;
        agent.photo = data.photo;
        agent.alias = data.alias;
        agent.idLastShift = data.id_last_shift;
        agent.currentPaydesk = data.current_id_paydesk;
        agent.keys_admin = data.keys_admin;
        agent.keys_basic = data.keys_basic;
        agent.app_platform = data.app_platform;
        agent.app_version = data.app_version;
        agent.pushPlatform = data.push_platform;
        agent.pushToken = data.push_token;
        agent.shuttlePushToken = data.shuttle_push_token;
        agent.premium = AgentBuilder.buildAgentPremium(data.premium);
        agent.products = _.map(data.products, (product) => {
            return AgentBuilder.buildAgentProducts(product);
        });
        agent.permissionGroup = AgentBuilder.buildPermissionGroup(data.permissionGroup);
        return agent;
    }
    static buildPermissionGroup(data) {
        const agentPermissionGroup = new AdminPermissionsGroup();
        agentPermissionGroup.id = data.id;
        agentPermissionGroup.name = data.name;
        agentPermissionGroup.permissions = _.map(data.permissions, (permission) => {
            return AgentBuilder.buildPermissions(permission);
        });
        return agentPermissionGroup;
    }
    static buildPermissions(data) {
        const adminPermission = new AdminPermissions();
        adminPermission.id = data.id;
        adminPermission.name = data.name;
        return adminPermission;
    }
    static buildAgentProducts(dataProduct) {
        const agentProduct = new AgentProduct();
        agentProduct.id = dataProduct.product_id;
        agentProduct.name = dataProduct.product_name;
        agentProduct.service = dataProduct.service;
        agentProduct.rights =
            AgentBuilder.buildAgentProductsRights(dataProduct.rights);
        return agentProduct;
    }
    static buildAgentProductsRights(dataRights) {
        const agentProductRights = new AgentProductRights();
        if (!dataRights) {
            return agentProductRights;
        }
        agentProductRights.role = dataRights.role;
        agentProductRights.permissions =
            AgentBuilder.buildAgentProductPermissions(dataRights.permissions);
        return agentProductRights;
    }
    static buildAgentProductPermissions(dataPermissions) {
        const agentProductPermissions = new AgentProductPermissions();
        if (!dataPermissions) {
            return agentProductPermissions;
        }
        agentProductPermissions.manageAgents = dataPermissions.manage_agents;
        agentProductPermissions.manageProduct = dataPermissions.manage_product;
        agentProductPermissions.manageReservations =
            dataPermissions.manage_reservations;
        return agentProductPermissions;
    }
    static buildAgentPremium(dataPremium) {
        const agentPremium = new AgentPremium();
        if (!dataPremium) {
            return agentPremium;
        }
        if (dataPremium.position) {
            const locationAgent = new LocationAgent(dataPremium.position.lat, dataPremium.position.lng, dataPremium.position.position_description, new Date(dataPremium.position.timestamp));
            agentPremium.position = locationAgent;
        }
        agentPremium.agentStatusDate = new Date(dataPremium.status_timestamp);
        agentPremium.reservationId = dataPremium.reservation_id;
        agentPremium.agentStatus = dataPremium.agent_status;
        agentPremium.multireception = dataPremium.multireception;
        agentPremium.id_multireception_terminal = dataPremium.id_multireception_terminal;
        if (dataPremium.current_request_expiration_time) {
            agentPremium.requestExpirationTime =
                new Date(dataPremium.current_request_expiration_time);
        }
        return agentPremium;
    }
    static buildAgentServicesList(data) {
        const agentServices = new AgentServicesList();
        agentServices.page = data.page;
        agentServices.pagination = data.pagination;
        agentServices.totalServices = data.total_services;
        agentServices.reservations = _.map(data.reservations, (reservation) => {
            return ReservationBuilder.buildReservation(reservation);
        });
        return agentServices;
    }
    static buildAgentServicePayload(agentService) {
        const extras = _.map(agentService.extras, (extra) => {
            return { extra_id: extra.extra.id };
        });
        return {
            agent_observations: agentService.agentObservations,
            start_date: agentService.startDate.toISOString(),
            end_date: agentService.endDate.toISOString(),
            extras,
            paymethod_id: agentService.paymentMethodId,
            profile_id: agentService.profileId,
            use_points: agentService.usePoints,
            trip: ReservationBuilder.buildReservationTripPayload(agentService.trip),
            space_number: agentService.spaceNumber,
            calle: agentService.calle,
            id_image_in_signature: agentService.idImageInSignature,
            invoice_requested: agentService.invoice_requested,
            invoice_address: agentService.invoice_address,
            invoice_city: agentService.invoice_city,
            invoice_email: agentService.invoice_email,
            invoice_name: agentService.invoice_name,
            invoice_nif: agentService.invoice_nif,
            invoice_state: agentService.invoice_state,
            invoice_zip: agentService.invoice_zip,
            invoice_country: agentService.invoice_country,
            promocode: agentService.promotions && agentService.promotions.length ? agentService.promotions[0].code : [],
            premium_checkout_vehicle_status: agentService.premium_checkout_vehicle_status,
            premium_checkout_vehicle_observations: agentService.premium_checkout_vehicle_observations
        };
    }
    static buildServiceUnassignationPayload(serviceUnassignation) {
        return {
            agent_id: serviceUnassignation.agentId,
            reason: {
                info: serviceUnassignation.reason.info,
                type: serviceUnassignation.reason.type
            }
        };
    }
    static buildAgentServicePhotosList(data) {
        const agentServicePhotosList = new AgentServicePhotosList();
        agentServicePhotosList.photos = _.map(data.images, (photo) => {
            return AgentBuilder.buildAgentServicePhoto(photo);
        });
        return agentServicePhotosList;
    }
    static buildAgentServicePhoto(data) {
        const agentServicePhoto = new AgentServicePhoto();
        agentServicePhoto.id = data.id;
        agentServicePhoto.idReservation = data.id_reservation;
        agentServicePhoto.imageName = data.image_name;
        agentServicePhoto.creationDate = data.creation_date;
        agentServicePhoto.url = data.url;
        return agentServicePhoto;
    }
}
//# sourceMappingURL=agent-builder.js.map